import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import StampWriteOff from '../../types/api/stamp-write-off'
import getQuery from '../../helpers/api/get-query'

export const stampWriteOffsApi = createApi({
    reducerPath: 'stampWriteOffsApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['StampWriteOffs'],
    endpoints: builder => ({
        getStampWriteOffs: builder.query<Strapi<StampWriteOff>, EndpointQueryParameters | void>({
            query: getQuery('/stamp-write-offs'),
        }),
        createStampWriteOff: builder.mutation<
            StrapiSingle<StampWriteOff>,
            StrapiCreate<StampWriteOff>
        >({
            query: body => ({
                url: '/stamp-write-offs',
                method: 'POST',
                body,
            }),
        }),
        updateStampWriteOff: builder.mutation<
            StrapiSingle<StampWriteOff>,
            StrapiUpdate<StampWriteOff>
        >({
            query: ({ docId, body }) => ({
                url: `/stamp-write-offs/${docId}`,
                method: 'PUT',
                body,
            }),
        }),
    }),
})

export const {
    useGetStampWriteOffsQuery,
    useCreateStampWriteOffMutation,
    useUpdateStampWriteOffMutation,
} = stampWriteOffsApi
